import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { layoutAsyncConnect } from 'utils/asyncConnectWrapper';
import { isLoading, load, get } from '../reducers/nonRunners';

import HorseRacingNonRunners from '../components/HorseRacingNonRunners';

@layoutAsyncConnect(
  "HorseRacingNonRunnersContainer",
  [{
    dispatch: () => load(),
    preventResolve: ({state}) => isLoading(state),
    refreshInterval: 30000,
    state: state => get(state)
  }]
)
export default class HorseRacingNonRunnersContainer extends Component {
  static propTypes = {
    meetings: PropTypes.array
  }

  render() {
    return <HorseRacingNonRunners meetings={this.props.meetings}/>
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingNonRunnersContainer.js